<template>
  <div :class="bootstrapClass">
    <div class="box box-secondary box-solid collapsed-box">
      <div class="box-header no-border">
        <h3 class="box-title">{{title | translate}}</h3>
      </div>
      <div class="info-box bg-secondary-active no-margin">
        <span class="info-box-icon"><i :class="['fa', icon]"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">
            {{'window_stores' | translate}}:
            <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
            <span v-else>{{items.window_stores}}</span> <br/>
            Click & Collect:
            <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
            <span v-else>{{items.click_and_collect_stores}}</span>
          </span>
          <span class="info-box-number">
            <span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
            <span v-else>{{items.stores}}</span>
            <small> {{title | translate}}</small>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['items', 'title', 'icon', 'bootstrapClass', 'loading'],
    data () {
      return {
      }
    },
    methods: {
      getIcon (status) {
        switch (status) {
          case 'warning':
            return ['fa', 'fa-warning', 'mr-5']
          case 'success':
            return ['fa', 'fa-check', 'mr-5']
          case 'danger':
            return ['fa', 'fa-bolt', 'mr-5']
        }
      }
    },
    mounted () {
    },
    watch: {
     items () {
    },
  timeSelector () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/PaymentStoresBoxComponent.vue